import { Tabs } from '@material-ui/core';
import { RouterUrlEnum } from 'enums/routerUrl';
import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { TrustedRoutes } from 'utils/constants/router.const';
import { getEnvironment } from 'utils/handlers/envHandler';
import { isInIFrame } from 'utils/services/kenticoSdk.service';
import { CustomNavbarContainer, CustomNavbarTab } from './CustomNavbar.styled';

interface IState {
  selectedTab: string;
}

type PropType = WithTranslation & RouteComponentProps;

class CustomNavbar extends Component<PropType, IState> {
  constructor(props: PropType) {
    super(props);
    this.state = { selectedTab: RouterUrlEnum.ADD_MANY_CONTENT };
  }

  componentDidMount(): void {
    const {
      history: {
        location: { pathname },
      },
    } = this.props;
    const selectedRoute =
      !!TrustedRoutes.find((route) => route.pathname === pathname) && pathname !== RouterUrlEnum.HOME
        ? pathname
        : RouterUrlEnum.ADD_MANY_CONTENT;

    this.redirect(selectedRoute);
  }

  handleOpenLink = (filename: string) => (): void => {
    window.open(`${getEnvironment('REACT_APP_APPLICATION_URL')}/docs/${filename}`, '_blank');
  };

  onTabChange = (_event: React.ChangeEvent<{}>, newValue: string): void => {
    this.redirect(newValue);
  };

  redirect = (newValue: string): void => {
    const { history } = this.props;

    this.setState({
      selectedTab: newValue,
    });
    history.push(newValue);
  };

  render(): JSX.Element {
    const { t } = this.props;
    const { selectedTab } = this.state;

    return (
      <CustomNavbarContainer>
        <Tabs value={selectedTab} textColor="secondary" onChange={this.onTabChange} aria-label="tab">
          {isInIFrame && (
            <CustomNavbarTab label={t('common.tab.addContentTab')} id="add-content" value={RouterUrlEnum.ADD_CONTENT} />
          )}
          <CustomNavbarTab
            label={t('common.tab.addManyContentsTab')}
            id="add-many-contents"
            value={RouterUrlEnum.ADD_MANY_CONTENT}
          />
          <CustomNavbarTab
            label={t('common.tab.translationProgress')}
            id="translation-progress"
            value={RouterUrlEnum.TRANSLATION_PROGRESS}
          />
        </Tabs>
      </CustomNavbarContainer>
    );
  }
}

export default withTranslation()(withRouter(CustomNavbar));
